var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "swiper",
    {
      staticClass: "swiper section my-auto",
      attrs: { options: _vm.swiperOption }
    },
    [
      _c("swiper-slide", { staticClass: "card-ctn" }, [
        _c(
          "div",
          { staticClass: "neu-card" },
          [
            _c("base-icon", {
              attrs: {
                src:
                  "/static-appopensalud/img/icons/morillas-svg-icons/neu/star.svg",
                white: "",
                fullWidth: "",
                shadow: ""
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "subtitle" }, [
          _c("p", [_vm._v("Selecciona")]),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "\n        Selecciona las especialidades que desees (¡más de 40 disponibles!)\n      "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("swiper-slide", { staticClass: "card-ctn" }, [
        _c(
          "div",
          { staticClass: "neu-card" },
          [
            _c("base-icon", {
              attrs: {
                src:
                  "/static-appopensalud/img/icons/morillas-svg-icons/neu/price.svg",
                white: "",
                fullWidth: "",
                shadow: ""
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "subtitle" }, [
          _c("p", [_vm._v("Servicios y horarios")]),
          _vm._v(" "),
          _c("span", [
            _vm._v("\n        Elige los servicios y horarios"),
            _c("br"),
            _vm._v(
              "Videoconsulta, Consulta por Escrito, Chat, Llamada telefónica, etc.\n      "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("swiper-slide", { staticClass: "card-ctn" }, [
        _c(
          "div",
          { staticClass: "neu-card" },
          [
            _c("base-icon", {
              staticClass: "my-auto",
              attrs: {
                src:
                  "/static-appopensalud/img/icons/morillas-svg-icons/neu/lock.svg",
                white: "",
                fullWidth: "",
                shadow: ""
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "subtitle" }, [
          _c("p", [_vm._v("Determina")]),
          _vm._v(" "),
          _c("span", [
            _vm._v("\n        Determina los beneficiarios"),
            _c("br"),
            _vm._v(
              "Empleados, clientes, cónyuge/pareja, hijos, etc. (¡más de 40 disponibles!)\n      "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "swiper-pagination",
        attrs: { slot: "pagination" },
        slot: "pagination"
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39117450", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39117450","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/testing/SwiperTesting.vue
// module id = 4114
// module chunks = 33